import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-28 px-6 overflow-hidden" data-id="element-27">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-white/60 blur-3xl rounded-full -z-10 pointer-events-none" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-29">
        <FadeIn data-id="element-30">
          <span className="text-gold font-semibold tracking-wider text-sm md:text-base uppercase mb-4 block" data-id="element-31">
            Una guía práctica y espiritual
          </span>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-navy leading-tight mb-6" data-id="element-32">
            MÉTODO 7-D MORNINGS:
            <br data-id="element-33" />
            <span className="italic text-navy/90" data-id="element-34">
              El Despertar de la Gracia
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-35">
          <p className="text-lg md:text-xl text-navy/80 max-w-2xl mx-auto leading-relaxed mb-12" data-id="element-36">
            Vence la parálisis matutina y recupera tu voluntad en 7 días con
            micropasos de inercia cero y fundamentos bíblicos.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="relative max-w-2xl mx-auto mb-16" data-id="element-37">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-navy/10 transform transition-transform hover:scale-[1.02] duration-500" data-id="element-38">
            <img src="https://cdn.magicpatterns.com/uploads/fzHyLZJbNMep58WjHsxjsC/heylloyd-image-1775939581053.png" alt="Método 7-D Mornings en iPad" className="w-full h-auto object-cover" data-id="element-39" />
          </div>
          {/* Decorative elements behind image */}
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-sage/20 rounded-full blur-xl -z-10" data-id="element-40"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-gold/20 rounded-full blur-xl -z-10" data-id="element-41"></div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-42">
          <CTAButton data-id="element-43">QUIERO RECUPERAR MIS MAÑANAS</CTAButton>
        </FadeIn>
      </div>
    </section>;
}